import { ISGWTConnectConfigurationStrict } from './SGWTConnectConfiguration';

/**
 * Generates a cryptographically strong random value.
 */
export function generateCryptoStrongRandomValue(): string {
  const crypto = window.crypto || (window as any).msCrypto;
  const randomValues = crypto.getRandomValues(new Uint32Array(5)) as Uint32Array;
  // IE supports neither TypedArray methods nor Array.from,
  // so we have to use a for loop here if we want this script
  // to be injectable before polyfills:
  let base36RandomValue = '';
  for (let i = 0; i < randomValues.length; i += 1) {
    base36RandomValue += randomValues[i].toString(36);
  }
  return base36RandomValue;
}

/**
 * Normalizes the authorization endpoint by stripping /oauth2/* suffixes.
 */
export function normalizeAuthorizationEndpoint(authorization_endpoint: string): string {
  return authorization_endpoint.replace(/(\/oauth2\/authorize|\/userinfo)?\/?$/, '');
}

interface IGenerateAuthorizationUriOptions {
  prompt?: string; // http://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
  id_token_hint?: string; // https://openid.net/specs/openid-connect-session-1_0.html#OPiframe
}

/**
 * Generates an OAuth2/OpenID-compliant authorization URI.
 */
export function generateAuthorizationUri(
  config: ISGWTConnectConfigurationStrict,
  state: string,
  options?: IGenerateAuthorizationUriOptions,
): string {
  return (
    normalizeAuthorizationEndpoint(config.authorization_endpoint) +
    '/oauth2/authorize' +
    '?client_id=' +
    encodeURIComponent(config.client_id) +
    '&redirect_uri=' +
    encodeURIComponent(config.redirect_uri) +
    '&response_type=' +
    encodeURIComponent(config.response_type) +
    '&scope=' +
    encodeURIComponent(config.scope) +
    (config.with_nonce ? `&nonce= ${encodeURIComponent(generateCryptoStrongRandomValue())}` : '') +
    '&state=' +
    encodeURIComponent(state) +
    '&acr_values=' +
    encodeURIComponent(config.acr_values) +
    (options && options.prompt ? '&prompt=' + options.prompt : '') +
    (options && options.id_token_hint ? '&id_token_hint=' + options.id_token_hint : '')
  );
}
